import { jsx } from "react/jsx-runtime";
import CachedIcon from "@mui/icons-material/Cached";
import { validateTidalLicense } from "../../base/index.js";
function Cached(props) {
  return /* @__PURE__ */ jsx(
    CachedIcon,
    {
      "data-testid": "Cached",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Cached",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Cached.tidalIconMeta = {
  categories: "fileActions",
  name: "Cached"
};
validateTidalLicense();
export {
  Cached
};
//# sourceMappingURL=Cached.js.map
